<mat-form-field fxFlex="0 0 100%" appearance="outline" [formGroup]="frmGroup" color="accent">    
    <textarea matInput hidden></textarea>
    <div fxFlex>
        <div>
            <div class="row">
                <div [ngClass]="getColsClass()"
                    *ngFor="let shipment of frmGroup.get(configData.name)['shipmentList']; let rowIndex=index">
                    <div style="cursor: pointer;" class="card-box" (click)="editShipmentForm(shipment, rowIndex)">                    
                        <div style="width: 12%;float: right;margin-right: 9%;height: 20%;" [ngClass]="{'hidden': (formStatus === 'DISABLED')}">
                            <button type="button" mat-icon-button class="close-card"
                                (click)="deleteShipmentCard(rowIndex)" matTooltip="Remove ship unit">
                                <mat-icon style="font-size: 35px;" color="accent">close</mat-icon>
                            </button>
                        </div>
                        <div style="text-align:center; padding: 15% 0 10% 0;height: 30%; clear: both;">
                            <div style="font-size: 25px;">
                                {{shipment.huCount}} {{shipment.handlingUnit.displayValue}}
                            </div>
                            <div style="line-height: 24px;font-size: 17px;">
                                {{shipment.length}} {{configData.controls[3].suffix}} x {{shipment.width}} {{configData.controls[4].suffix}} 
                                x {{shipment.height}} {{configData.controls[5].suffix}} 
                            </div>
                            <div style="line-height: 24px;
                            font-size: 15px;">
                                <span> {{shipment.unitWeight}} {{configData.controls[2].suffix}}</span>
                            </div>
                        </div>                        
                    </div>
                    <mat-error *ngIf="rowIndex === 0">
                        <mat-error style="margin-top: 7px;" *ngIf="frmGroup.get(configData.name).errors">
                            <mat-error *ngIf="frmGroup.get(configData.name).errors.totalShipCount">
                                {{frmGroup.get(configData.name).errors.totalShipCount}}
                            </mat-error>
                        </mat-error>
                    </mat-error>
                </div>
                <div [ngClass]="getColsClass()">
                    
                    <div style="height: 280px;cursor: pointer;" *ngIf="!(formStatus === 'DISABLED')">
                        <div (click)="openShipmentForm()" class="row mat-header-row" style="border-bottom: 0px;">
                            <div class="col mat-header-cell" style="font-size: 14px;text-align:center; padding: 15px;">
                                <div style="padding: 100px 3px;">
                                    <a href="#" (click)="$event.preventDefault();">+ Add
                                        {{configData.label}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-error style="margin-top: 7px;" *ngIf="frmGroup.get(configData.name).errors">
                        <mat-error *ngIf="frmGroup.get(configData.name).errors.shipCard">
                            {{frmGroup.get(configData.name).errors.shipCard}}
                        </mat-error>
                    </mat-error>
                </div>
            </div>
        </div>
    </div>    
</mat-form-field>